<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :value="computedDataFormatada"
        :label="label"
        :disabled="disabled"
        prepend-icon="mdi-calendar"
        readonly
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker v-model="data" scrollable locale="pt-br">
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="setData(); menu = false">OK</v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: "DateMenu",

  props: {
    label: {
      type: String,
      default: "DateMenu"
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      menu: false,
      data: this.$functions.dateStringMonth(new Date().toISOString().substr(0, 10), 1)
    };
  },

  computed: {
    computedDataFormatada() {
      this.setData();
      return this.formatData(this.data);
    }
  },

  methods: {
    formatData(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    setData(menu) {
      this.$emit("onChanged", this.data);
    }
  }
};
</script>
